import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Box,
  Flex,
  useColorModeValue,
  Avatar,
  Heading,
  Stack,
  Text,
  Image,
  Spacer,
  Center,
  HStack,
  VStack,
  Skeleton,
  SimpleGrid,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { CgChevronLeft, CgChevronRight, CgMail, CgPhone } from "react-icons/cg";
import { PhoneIcon, EmailIcon } from "@chakra-ui/icons";
import AuthContext from "../contexts/AuthContext";
import { useMultiState } from "../lib/hooks";
import { useQuery } from "@apollo/client";
import { useHistory, useParams } from "react-router";
import subjects from "../graphql/queries/subjectsbyteacherId";
import ProfileList from "../components/ProfileList";
import userbyID from "../graphql/queries/userbyID";

import {
  Previous,
  Paginator,
  PageGroup,
  Page,
  Next,
  generatePages,
} from "chakra-paginator";
import { useTranslation } from "react-i18next";

const ShowProfilePage = () => {
  const { t } = useTranslation();
  const bg = useColorModeValue("white", "gray.900");
  const cardbg = useColorModeValue("gray.50", "inherit");
  const cardbox = useColorModeValue("gray.200", "whiteAlpha.200");
  const cs = useColorModeValue("gray.700", "gray.400");

  const history = useHistory();
  const { user } = useContext(AuthContext);
  const params = useParams();
  const [profileUser, setProfileUser] = useMultiState();

  const { data: subjectData } = useQuery(subjects, {
    variables: {
      teacher: params?.userId,
    },
  });

  const { data: profile, loading } = useQuery(userbyID, {
    variables: {
      _id: params?.userId,
    },
  });

  const [subjectState, setSubjectState] = useState([]);

  const subjectCardBg = useColorModeValue("#2e86c1", "#87CEEB");
  const itemLimit = 4;

  const [pagesQuantity, setPagesQuantity] = useState(0);
  const [curPage, setCurPage] = useState(0);

  const normalStyles = {
    bg: "white",
  };

  const activeStyles = {
    bg: "blue.300",
  };

  const handlePageChange = (page) => {
    setCurPage(page - 1);
  };
  // console.log(pagesQuantity)
  useEffect(() => {
    const pagesTotal = Math.ceil(subjectData?.subjects?.length / itemLimit);
    setPagesQuantity(pagesTotal);
    setProfileUser(profile?.userId);
    if (subjectData) {
      setSubjectState(subjectData?.subjects ? subjectData?.subjects : []);
    }
  }, [
    history,
    user,
    subjectData,
    subjectData?.subjects?.length,
    curPage,
    itemLimit,
    profile,
  ]);
  // console.log(profileUser)
  return (
    <Fragment>
      <Box bg={cardbg} p={10} mt={7}>
        <Stack align={{ base: "center", md: "flex-start" }}>
          <Heading size="xl">{t("showprofilePage.firstTitle")}</Heading>
        </Stack>
        <Box visibility={{ base: "hidden", sm: "visible" }} aria-hidden="true">
          <Box py={2}>
            <Box borderTop="solid 1px" borderTopColor={cardbox}></Box>
          </Box>
        </Box>
        {loading ? (
          <Box w="full" py={2}>
            <Center>
              <Skeleton w="full" h="300px" />
            </Center>
          </Box>
        ) : (
          <Box position="relative" mb={10}>
            {/* Background Image */}
            <Box
              height="200px"
              backgroundImage={`url(https://media.istockphoto.com/id/1419766496/photo/abstract-concepts-of-cybersecurity-technology-and-digital-data-protection-protect-internet.webp?b=1&s=612x612&w=0&k=20&c=mMG_-IOsy9IOupqSDvEbeqduD-LGZ3bBp1fZ5pXoIwA=)`}
              backgroundSize="cover"
              backgroundPosition="center"
              borderTopRadius="lg"
            />

            {/* Profile Content */}
            <Center>
              <Box
                position="absolute"
                top="110px"
                display="flex"
                flexDirection="column"
                alignItems="center"
                bg="rgba(255, 255, 255, 0)"
                p={6}
                w={{ base: "90%", sm: "70%", md: "50%" }}
              >
                <Avatar
                  size="2xl"
                  name={`${profileUser?.firstname} ${profileUser?.lastname}`}
                  src={profileUser?.avatar || "../images/avatar.png"}
                  mb={4}
                />
                <Heading fontSize="2xl">
                  {`${profileUser?.firstname} ${profileUser?.lastname}`}
                </Heading>
                <HStack spacing={2} mt={2}>
                  {profileUser?.email && (
                    <>
                      <EmailIcon color="gray.500" />
                      <Text color="gray.600" fontSize="sm">
                        {profileUser?.email}
                      </Text>
                    </>
                  )}
                </HStack>
                {profileUser?.mobile && (
                  <HStack spacing={2} mt={1}>
                    <PhoneIcon color="gray.500" />
                    <Text color="gray.600" fontSize="sm">
                      {profileUser?.mobile}
                    </Text>
                  </HStack>
                )}
                {profileUser?.description && (
                  <Text textAlign="center" color={cs} fontSize="sm" mt={4}>
                    {profileUser?.description}
                  </Text>
                )}
              </Box>
            </Center>
          </Box>
        )}
      </Box>
      <Box bg={useColorModeValue("gray.50", "inherit")} p={10} py={7}>
        {profileUser?.role === "TEACHER" ? (
          <Box mt="70px">
            <Heading
              size="lg"
              mb={4}
              textAlign="center"
              color="black"
            >
              {t("showprofilePage.allCourse")}
            </Heading>
           <SimpleGrid minChildWidth="280px" spacing={6}>
              {subjectState
                .slice(curPage * itemLimit, curPage * itemLimit + itemLimit)
                .map((subject) => (
                   <Link
                      to={`/subject/${subject._id}`}
                      style={{ textDecoration: "none", width: "100%" }}
                    >
                  <Box
                    key={subject._id}
                    p={4}
                    bg={subjectCardBg}
                    borderRadius="md"
                    boxShadow="md"
                    h="200px"
                    w="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center" // center vertically
                    alignItems="center" // center horizontally
                    textAlign="center" // center text inside heading
                    _hover={{ boxShadow: "xl", transform: "scale(1.02)" }}
                    transition="all 0.2s"
                  >
                   
                      <Heading size="md" mb={2} color="white" noOfLines={4}>
                        {subject.name}
                      </Heading>
                    
                  </Box>
                  </Link>
                ))}
            </SimpleGrid>

            {pagesQuantity !== 0 ? (
              <Flex p={2}>
                <Spacer />
                <Paginator
                  onPageChange={handlePageChange}
                  pagesQuantity={pagesQuantity}
                >
                  <Previous bg={bg}>
                    <CgChevronLeft />
                  </Previous>
                  <PageGroup>
                    {generatePages(pagesQuantity)?.map((page) => (
                      <Page
                        key={`paginator_page_${page}`}
                        page={page}
                        normalStyles={normalStyles}
                        activeStyles={activeStyles}
                      />
                    ))}
                  </PageGroup>
                  <Next bg={bg}>
                    <CgChevronRight />
                  </Next>
                </Paginator>
              </Flex>
            ) : (
              <Text fontSize={"30"} mt={3} color={"gray.500"}>
                {t("courseteacherPage.alt")}
              </Text>
            )}
          </Box>
        ) : null}
      </Box>
      <Box h="70px"></Box>
    </Fragment>
  );
};
export default ShowProfilePage;
